import {
  NonSimulatorFeatureAppName,
  SimulatorFeatureAppName,
} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';
import {
  generateFeatureAppId,
  LayerButtonFeatureAppContentConfig,
  NaturalLanguageFeatureAppContentConfig,
} from '@volkswagen-onehub/whitelabel-e-mobility-commons';
import {
  FeatureAppConfiguration,
  FeatureappServiceV1,
} from '@volkswagen-onehub/featureapp-service';
import {Logger} from '@feature-hub/core';

const LAYER_BUTTON_FA_NAME = 'eMob_LayerButton';

export interface LayerButtonFeatureAppConfiguration {
  featureAppConfiguration: FeatureAppConfiguration;
  appDataContent: LayerButtonFeatureAppContentConfig;
  featureAppId: string;
}

export function getLayerButtonFeatureAppConfiguration(
  naturalLanguageFeatureAppId: string,
  naturalLanguageAppDataContent: NaturalLanguageFeatureAppContentConfig,
  customFeatureAppConfigurations: object | undefined,
  featureAppService: FeatureappServiceV1,
  logger: Logger | undefined
): LayerButtonFeatureAppConfiguration {
  let customFeatureAppConfigurationName = undefined;
  if (
    customFeatureAppConfigurations &&
    typeof customFeatureAppConfigurations === 'object'
  ) {
    customFeatureAppConfigurationName = Object.entries(
      customFeatureAppConfigurations
    ).find(([key, value]) => {
      return key === NonSimulatorFeatureAppName.LayerButton && value;
    })?.[1];
  }

  let layerButtonFeatureAppConfiguration =
    featureAppService.featureAppConfigurations[LAYER_BUTTON_FA_NAME];
  if (customFeatureAppConfigurationName) {
    const customConfiguration =
      featureAppService.featureAppConfigurations[
        customFeatureAppConfigurationName
      ];
    if (customConfiguration) {
      layerButtonFeatureAppConfiguration = customConfiguration;
    } else {
      logger?.warn(
        `No custom feature app configuration with name '${customFeatureAppConfigurationName}' found. Using '${LAYER_BUTTON_FA_NAME}' instead.`
      );
    }
  }

  if (layerButtonFeatureAppConfiguration) {
    const featureAppId = generateFeatureAppId(
      naturalLanguageFeatureAppId,
      NonSimulatorFeatureAppName.LayerButton
    );

    const {
      fa,
      buttonLabel,
      closeButtonLabel,
      hideVehicleImage,
      hideConfigureButton,
      contentHeadline,
      strictSelection,
    } = naturalLanguageAppDataContent;
    const appDataContent = {
      fa: fa.length > 0 ? fa : Object.values(SimulatorFeatureAppName),
      emphasis: 'secondary',
      hideIfNotAvailable: 'false',
      strictSelection,
      buttonLabel,
      closeButtonLabel,
      contentHeadline,
      hideVehicleImage,
      hideConfigureButton,
    } as LayerButtonFeatureAppContentConfig;

    return {
      featureAppConfiguration: layerButtonFeatureAppConfiguration,
      appDataContent,
      featureAppId,
    };
  } else {
    throw new Error(
      `No valid feature app configuration for '${NonSimulatorFeatureAppName.LayerButton}' found`
    );
  }
}
